import z from 'zod';
import { SelectOption } from 'global';
import { sendApplicationFormSchema } from './schema';

export type SendApplicationFormValues = z.infer<typeof sendApplicationFormSchema>;

export enum SendApplicationFormTemplates {
  Personal = 'personal',
  Lender = 'lender',
}

export interface SendCreditApplicationRenderProps {
  isDataLoading: boolean;
  isSendOcaLinkLoading: boolean;
  lenderProfilesWithOcaOptions: SelectOption[];
  handleSendOcaLink: (values: SendApplicationFormValues) => Promise<string | null>;
}
